<template>
    <div class="ticket-check__info">
        <span class="info-message">
            {{ active === true ? $t('repeatTicketMsg') : '' }}
        </span>
    </div>
</template>

<script>
    export default {
        name: 'TicketCompileInfo',
        props: {
            active: Boolean
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/checkTicket/TicketCompileInfo.vue